import { render } from "./MenuItemComponent.vue?vue&type=template&id=4ac81587"
import script from "./MenuItemComponent.vue?vue&type=script&lang=js"
export * from "./MenuItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__